var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEncryption = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.33332H9.33335V3.99999C9.33335 2.15999 7.84002 0.666656 6.00002 0.666656C4.16002 0.666656 2.66669 2.15999 2.66669 3.99999V5.33332H2.00002C1.26669 5.33332 0.666687 5.93332 0.666687 6.66666V13.3333C0.666687 14.0667 1.26669 14.6667 2.00002 14.6667H10C10.7334 14.6667 11.3334 14.0667 11.3334 13.3333V6.66666C11.3334 5.93332 10.7334 5.33332 10 5.33332ZM6.00002 11.3333C5.26669 11.3333 4.66669 10.7333 4.66669 9.99999C4.66669 9.26666 5.26669 8.66666 6.00002 8.66666C6.73335 8.66666 7.33335 9.26666 7.33335 9.99999C7.33335 10.7333 6.73335 11.3333 6.00002 11.3333ZM4.00002 5.33332V3.99999C4.00002 2.89332 4.89335 1.99999 6.00002 1.99999C7.10669 1.99999 8.00002 2.89332 8.00002 3.99999V5.33332H4.00002Z",
    fill: "#AFAFAE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEncryption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_encryption.25cfe32416cfdb5becd47c2480efba01.svg";